// components/Shimmer.jsx
const Shimmer = ({ className }) => (
  <div className={`relative overflow-hidden bg-gray-200 rounded-lg ${className}`}>
    <div className="absolute inset-0 -translate-x-full 
                    animate-[shimmer_2s_infinite] 
                    bg-gradient-to-r from-transparent via-white/60 to-transparent"></div>
  </div>
);

export default Shimmer;
